import { useAppStore } from '../state/store';
import { useInstallPrompt } from '../state/useInstallPrompt';
import { IconCrosshair, IconDownload, IconExternal, IconInfo, IconSearch } from './Icons';

const LOGO = `${import.meta.env.BASE_URL}favicon.svg`;

/** Intestazione del pannello desktop. */
export function Brand() {
  const setInfoOpen = useAppStore((s) => s.setInfoOpen);
  const { canInstall, install } = useInstallPrompt();
  return (
    <header className="brand">
      <img src={LOGO} alt="" width={32} height={32} className="brand__logo" />
      <div className="grow">
        <h1 className="brand__title">ShadowRoute</h1>
        <p className="brand__sub">Percorsi a piedi con più ombra</p>
      </div>
      {canInstall && (
        <button
          type="button"
          className="btn btn--xs btn--tinted"
          title="Installa come app"
          onClick={() => void install()}
        >
          <IconDownload size={14} /> Installa
        </button>
      )}
      <button
        type="button"
        className="icon-btn"
        aria-label="Come funziona"
        title="Come funziona"
        onClick={() => setInfoOpen(true)}
      >
        <IconInfo size={20} />
      </button>
    </header>
  );
}

/** Stato iniziale: invito a scegliere i punti. */
export function EmptyState() {
  return (
    <section className="card empty" data-peek>
      <div className="row" style={{ alignItems: 'flex-start' }}>
        <img src={LOGO} alt="" width={40} height={40} className="empty__logo" />
        <div className="grow">
          <div className="t-headline">Dove vuoi andare?</div>
          <p className="t-sub">
            Scegli partenza e arrivo: calcolo il percorso a piedi con più ombra, seguendo il sole
            mentre cammini.
          </p>
        </div>
      </div>
      <div className="empty__tips" aria-hidden="true">
        <span className="tip">
          <IconCrosshair size={13} /> Tocca la mappa
        </span>
        <span className="tip">
          <IconSearch size={13} /> Cerca un luogo
        </span>
        <span className="tip">
          <IconExternal size={13} /> Incolla un link di Google Maps
        </span>
      </div>
    </section>
  );
}

export function Footer() {
  const setInfoOpen = useAppStore((s) => s.setInfoOpen);
  return (
    <footer className="footer">
      Dati ©{' '}
      <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">
        OpenStreetMap
      </a>{' '}
      · meteo{' '}
      <a href="https://open-meteo.com/" target="_blank" rel="noreferrer">
        Open-Meteo
      </a>{' '}
      · calcoli nel tuo browser ·{' '}
      <button type="button" className="link" onClick={() => setInfoOpen(true)}>
        come funziona
      </button>
    </footer>
  );
}
